(function () {
  function bindExtraNavButtons(rootEl) {
    const prevBtn = rootEl.querySelector("#custom-swiper-a .swiper-button-prev");
    const nextBtn = rootEl.querySelector("#custom-swiper-a .swiper-button-next");
    if (!prevBtn || !nextBtn) return;
    const bind = (nodes, targetBtn) => {
      nodes.forEach((node) => {
        if (!node.dataset.bound) {
          node.addEventListener("click", () => targetBtn.click());
          node.dataset.bound = "1";
        }
      });
    };
    bind(document.querySelectorAll(".extra-prev"), prevBtn);
    bind(document.querySelectorAll(".extra-next"), nextBtn);
  }

  function initSwiper() {
    const swiperEl = document.getElementById("custom-swiper-a");
    if (!swiperEl || !window.Swiper) return;

    const isSmall = window.matchMedia("(max-width: 699px)").matches;

    new Swiper(swiperEl, {
      loop: true,
      watchSlidesProgress: true,

      /* 关键修复：所有视口都启用居中 */
      centeredSlides: true,

      slidesPerView: 1.2,
      spaceBetween: 10,

      breakpoints: {
        700: {
          slidesPerView: 2,      // 或 2.5 也行
          spaceBetween: 10,
          centeredSlides: true,  // 保持为 true
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 16,
          centeredSlides: true,  // 保持为 true
        },
      },

      lazy: {
        loadPrevNext: true,
        loadOnTransitionStart: false,
      },
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      }
    });

    bindExtraNavButtons(swiperEl);
  }

  if ("requestIdleCallback" in window) {
    requestIdleCallback(initSwiper, { timeout: 1500 });
  } else if (document.readyState === "complete") {
    initSwiper();
  } else {
    window.addEventListener("load", initSwiper, { once: true });
  }
})();
